import React, { useRef } from 'react';
var VeltCommentSidebarV2FilterContainerSectionControlChevron = function (props) {
    var up = props.up, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-sidebar-filter-container-v2-section-control-chevron", { ref: ref, up: [true, false].includes(up) ? (up ? 'true' : 'false') : undefined, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentSidebarV2FilterContainerSectionControlChevron;
